import React from 'react';
import {SafeAreaView, ScrollView} from 'react-native';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import BackSubheader from 'src/components/elements/BackSubheader';
import {NutritionFactsDisplay} from '../../elements/NutritionFactsDisplay/NutritionFactsDisplay';
import {ProductNutrition} from '../../../types/ProductType';

type ViewNutritionProps = {
  nutrition?: ProductNutrition;
  product?: any;
};

function ViewNutrition({nutrition, product}: ViewNutritionProps) {
  return (
    <BackSubheader title={nutrition?.productName}>
      <ScrollView style={{flex: 1}}>
        <SafeAreaView>
          <NutritionFactsDisplay nutrition={nutrition} product={product} />
        </SafeAreaView>
      </ScrollView>
    </BackSubheader>
  );
}

export default withForwardedNavigationParams()(ViewNutrition);
